<div class="mw-form-navigation bg-white">
  <a
    (click)="!item.isNavigationWidget ? onScrollIntoView(item.idAttr) : true"
    class="text-body-2"
    *ngFor="let item of sections"
    [ngClass]="{
      'mw-form-navigation__form-title': item.isFormTitle,
      'cursor-default': item.isNavigationWidget,
      'h-[50px] cursor-pointer hover:bg-graphite-50': !item.isNavigationWidget
    }"
  >
    <mat-icon
      class="mw-icon-20 mr-[16px] text-secondary-dark dark:text-secondary-light"
      [fontSet]="
        item.isOutlineIcon ? 'material-icons-outlined' : 'material-icons'
      "
    >
      {{ item.icon }}
    </mat-icon>
    <div class="mw-form-navigation__content">
      <div class="mw-form-navigation__title" *ngIf="item.title">
        {{ item.title }}
      </div>
      <div
        class="mw-form-navigation__sub-title truncate text-caption text-secondary-dark dark:text-secondary-light"
        *ngIf="item.subTitle"
      >
        {{ item.subTitle }}
      </div>
      <div
        class="mw-form-navigation__default-sub-title truncate text-caption text-disabled-dark dark:text-disabled-light"
        *ngIf="item.defaultSubTitle && !item.subTitle"
      >
        {{ item.defaultSubTitle }}
      </div>
      <div
        class="mw-form-navigation__sub-title-indicators truncate text-secondary-dark dark:text-secondary-light"
        *ngIf="item.subTitleIndicators"
      >
        {{ item.subTitleIndicators }}
      </div>
      <ng-container
        *ngIf="item.isNavigationWidget"
        [ngTemplateOutlet]="item.templateRef"
      ></ng-container>
    </div>
  </a>
</div>
